import { useEffect, useState } from 'react'
import useStepTemplate from 'hooks/useStepTemplate'

const useComplementaryData = ({ fireboltStep, customGoBack }) => {
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
    customGoBack,
  })

  const [isOpenModal, setIsOpenModal] = useState(false)
  const autofill = { email: fireboltStep.capturedData.email }
  const phoneError = fireboltStep.remoteErrors[0]?.validationResults[0].message
  const phoneMessageError = 'phone_already_registered'

  useEffect(() => {
    if (phoneError === phoneMessageError) {
      setIsOpenModal(true)
    }
  }, [])

  function closeModal() {
    setIsOpenModal(false)
  }

  return {
    handleGoBackform,
    runBeforeChangeStep,
    isOpenModal,
    closeModal,
    autofill,
  }
}

export default useComplementaryData
